import { render, staticRenderFns } from "./CreateRegionStep.vue?vue&type=template&id=ecaf2950&scoped=true"
import script from "./CreateRegionStep.vue?vue&type=script&lang=js"
export * from "./CreateRegionStep.vue?vue&type=script&lang=js"
import style0 from "./CreateRegionStep.vue?vue&type=style&index=0&id=ecaf2950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf2950",
  null
  
)

export default component.exports